<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToTabItem'
});
</script>
<template>
	<div v-show="show" v-if="lazy ? show : true" :key="langKey" class="to-tab-page-item" :class="setClass">
		<slot></slot>
	</div>
</template>

<script setup lang="ts">
import { computed, nextTick, onBeforeUnmount, inject, useSlots, watch } from 'vue'
import { ITabProvide } from './tab.vue'
import { langKey } from '@touchvue/locale'



interface TabItemProps {
	data?: any
	label?: string
	value?: string | number
	icon?: string
	pic?: string
	number?: string | number
	lazy?: boolean
	on?: boolean
	disabled?: boolean
	count?: string | number
}

const slots = useSlots()

const props = withDefaults(defineProps<TabItemProps>(), {
	data: null,
	label: '',
	value: '',
	icon: '',
	pic: '',
	number: '',
	lazy: false,
	on: false,
	disabled: false,
	count: ''
})

// 注入父组件的值
const tabProvide: ITabProvide = inject('TabProvide')

// computed
const setClass = computed(() => {
	let arr: string[] = []
	if (props.disabled) {
		arr.push('disabled')
	}
	return arr
})

const show = computed(() => {
	return tabProvide.selectValue.value === (props.value || props.label)
})

// 监听 label 变化，更新 tab 数据
watch(
	() => props.label,
	(newLabel, oldLabel) => {
		if (tabProvide && tabProvide.updateTabLabel) {
			tabProvide.updateTabLabel(oldLabel, newLabel)
		}
	}
)

// methods
function init() {
	const tabData = {
		label: props.label,
		value: props.value ? props.value : props.label,
		icon: props.icon,
		pic: props.pic,
		number: props.number,
		disabled: props.disabled,
		data: props.data,
		on: props.on,
		count: props.count,
		labelSlot: slots.label
	}
	tabProvide.addTab(tabData)
}

nextTick(() => {
	init()
})

onBeforeUnmount(() => {
	// tabProvide.removeTab(props.value)
})
</script>
